import { Model } from 'shared/services/api/models/Model'
import { NotepadProductFlagPharmaObl } from './notepadProductFlagPharmaObl'

import { ProductFlags } from './notepadResponseTypes'

export class NotepadProductFlags extends Model {
  public pharmaObl: Record<string, unknown>

  constructor(src: ProductFlags) {
    super(src)
    this.pharmaObl = src.pharmaObl
      ? new NotepadProductFlagPharmaObl(src.pharmaObl)
      : null
  }
}
